/** Every client of the platform with its access and fee, shared by every screen that lists them. */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { readPlatformClients, type PlatformClientResponse } from "@/shared/api";

export const CLIENTS_KEY = ["platform-clients"] as const;

export function useClients(): UseQueryResult<PlatformClientResponse[]> {
  return useQuery({
    queryKey: CLIENTS_KEY,
    retry: false,
    queryFn: async () => {
      const result = await readPlatformClients();
      if (result.data === undefined) throw new Error("Client directory unavailable");
      return result.data;
    },
  });
}
